export const getGrnListTab = (initialFilter = {}) => {
  return {
    field: 'preset',
    isPreset: true,
    defaultTab: 'draft',
    tabs: [
      {
        key: 'draft',
        label: 'Draft',
        preset: {
          ...initialFilter,
          grn_status: ['draft'],
        },
      },
      {
        key: 'pending',
        label: 'Pending',
        preset: {
          ...initialFilter,
          grn_status: ['pending'],
        },
      },
      {
        key: 'approved',
        label: 'Approved',
        preset: {
          ...initialFilter,
          grn_status: ['approved'],
        },
      },
      {
        key: 'completed',
        label: 'Completed',
        preset: {
          ...initialFilter,
          grn_status: ['completed'],
        },
      },
      {
        key: 'all',
        label: 'All',
        preset: {
          ...initialFilter,
        },
      },
    ],
  };
};
